/* eslint-disable no-console */
import axios from 'axios';

import {API_BASE_URL, API_ENDPOINT_JSON} from '../../../config';
import CRUDMethods from '../../../constants/CRUDConstants';
import useJSONStore from '../../../store/StaticJson/jsonStore';
import useUserStore from '../../../store/userStore/userStore';

const electricBoard = async (): Promise<any> => {
  const electricBoard = useJSONStore.getState().electricBoard;
  const token = useUserStore.getState().userToken;
  const setElectricBoard = useJSONStore.getState().setElectricBoard;

  if (electricBoard.length === 0) {
    await axios
      .request({
        method: CRUDMethods.GET,
        url: `${API_BASE_URL}${API_ENDPOINT_JSON.JSON.electricityBoard}`,
        headers: {
          Authorization: `Bearer ${token}`
        },
        params: {},
        data: {}
      })
      .then((res) => {
        setElectricBoard(res.data.data);
      })
      .catch((err) => {
        return err.message;
      });
  }
};

export default electricBoard;
